const DEFAULT_WIPAY_REQUEST_TIMEOUT_MS = 45000;
const DEFAULT_WIPAY_CALLBACK_TIMEOUT_MS = 45000;

function parsePositiveInt(value, fallback) {
  const parsed = parseInt(value, 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
}

/** WiPay payment-initiation HTTP request (checkout → WiPay). */
export const WIPAY_REQUEST_TIMEOUT_MS = parsePositiveInt(
  process.env.REACT_APP_WIPAY_REQUEST_TIMEOUT_MS,
  DEFAULT_WIPAY_REQUEST_TIMEOUT_MS
);

/** Client-side processing on `/payment/response` after WiPay redirects back. */
export const WIPAY_CALLBACK_PROCESSING_TIMEOUT_MS = parsePositiveInt(
  process.env.REACT_APP_WIPAY_CALLBACK_TIMEOUT_MS,
  DEFAULT_WIPAY_CALLBACK_TIMEOUT_MS
);
